import React from 'react';
import type { MenuDropdownItem } from 'hfs-common-ui';
import MobileMenuDropdownItem from '../MobileMenuDropdownItem/MobileMenuDropdownItem';
import * as S from './styled';

export interface Props {
  menu: MenuDropdownItem[];
  activeMenuId?: number;
  onClick: (menuItem: MenuDropdownItem) => void;
}
const MobileRightMenu = ({ menu, activeMenuId, onClick }: Props) => {
  return (
    <S.Nav>
      <S.NavMenu $mainMenu={true}>
        {menu.map((item) => (
          <MobileMenuDropdownItem
            onClick={onClick}
            selected={item.id === activeMenuId}
            menuItem={item}
            key={item.id}
            mainMenu={true}
          ></MobileMenuDropdownItem>
        ))}
      </S.NavMenu>
    </S.Nav>
  );
};

export default MobileRightMenu;
